export const MARK_AVO_STALE = 'MARK_AVO_STALE';
export const MARK_AVO_FRESH = 'MARK_AVO_FRESH';
